import {
  asBoolean,
  isArray,
  isNumber,
  isObject,
  isString,
  maybeNumber,
  maybeString,
  StringFormat,
} from 'validata';

export type TokenPayload = {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  naf?: number;
  nbf: number;
  oid?: string;
  patrolId?: string;
  rem: boolean;
  rls: string[];
  sa: boolean; // super admin
  sid: string;
  shr: boolean; // shared device
  sty: string;
  sub: string;
  typ: string;
};

// NOTE: for some reason there is a weird build error if this is used by web
export const checkTokenPayload = isObject<TokenPayload>(
  {
    aud: isString(),
    exp: isNumber(),
    iat: isNumber(),
    iss: isString(),
    jti: isString({ format: StringFormat.ULID() }),
    naf: maybeNumber(),
    nbf: isNumber(),
    oid: maybeString(),
    patrolId: maybeString(),
    rem: asBoolean({ default: false }),
    rls: isArray(isString()),
    sa: asBoolean({ default: false }),
    shr: asBoolean({ default: false }),
    sid: isString(),
    sty: isString(),
    sub: isString(),
    typ: isString(),
  },
  { stripExtraProperties: true },
);
